// extracted by mini-css-extract-plugin
module.exports = {"paypal_modal__header":"modal-header-module--paypal_modal__header--2Vjc4"};